import { render, staticRenderFns } from "./Santen.vue?vue&type=template&id=252ad678&scoped=true"
import script from "./Santen.vue?vue&type=script&lang=js"
export * from "./Santen.vue?vue&type=script&lang=js"
import style0 from "./Santen.vue?vue&type=style&index=0&id=252ad678&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ad678",
  null
  
)

export default component.exports